import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { DEFAULT_APP_THEME_ID } from '@disenchantment/shared';
import { applyUserAppTheme } from '@/features/theme/applyUserAppTheme';
import './index.css';

applyUserAppTheme(DEFAULT_APP_THEME_ID, null);
import { Providers } from './app/providers';
import { AppRouter } from './app/router';

const root = document.getElementById('root');
if (!root) throw new Error('#root element not found');

createRoot(root).render(
  <StrictMode>
    <Providers>
      <AppRouter />
    </Providers>
  </StrictMode>
);
